module.exports = __webpack_public_path__ + "static/media/card.502d51df.webp";